import { render, staticRenderFns } from "./ProfitabilityChartCard.vue?vue&type=template&id=f15792f4&scoped=true"
import script from "./ProfitabilityChartCard.vue?vue&type=script&lang=js"
export * from "./ProfitabilityChartCard.vue?vue&type=script&lang=js"
import style0 from "./ProfitabilityChartCard.vue?vue&type=style&index=0&id=f15792f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15792f4",
  null
  
)

export default component.exports